import { render, staticRenderFns } from "./face-result.vue?vue&type=template&id=3485ef90&scoped=true"
import script from "./face-result.vue?vue&type=script&lang=js"
export * from "./face-result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3485ef90",
  null
  
)

export default component.exports